// toFilterParams.ts
// Convierte los columnFilters de la tabla (MRT) en query params { campo: valor }
// que entiende el backend (TipoRiesgoFilterDTO: nombre, estado).
export const toFilterParams = (columnFilters: any = []): Record<string, string> => {
  const arr = Array.isArray(columnFilters) ? columnFilters : [];
  const params: Record<string, string> = {};

  for (const { id, value } of arr) {
    if (value === undefined || value === null || value === '') continue;
    params[id] = String(value);
  }

  return params;
};
